import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import styled from 'styled-components';

const TERMS_BASE_URL = 'https://noobook-pub.s3.ap-northeast-2.amazonaws.com/terms';

const TERMS_CONFIG: Record<string, { title: string; url?: string; content?: string }> = {
  service: {
    title: '서비스 이용약관',
    url: `${TERMS_BASE_URL}/terms_use.html`,
  },
  privacy: {
    title: '개인정보 수집 및 이용 동의',
    url: `${TERMS_BASE_URL}/privacy_policy.html`,
  },
  marketing: {
    title: '마케팅 목적 개인정보 수집 이용 동의',
    content: '여기에 마케팅 목적 개인정보 수집 이용 동의 전문이 들어갑니다.',
  },
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 480px;
  margin: 0 auto;
  min-height: 100vh;
  padding: 24px 24px 24px;
  box-sizing: border-box;
`;

const Title = styled.h2`
  font-size: 1.2rem;
  font-weight: bold;
  margin: 0 0 16px;
  flex-shrink: 0;
`;

const Content = styled.div`
  background: #fafafa;
  border-radius: 8px;
  padding: 16px;
  min-height: 300px;
  white-space: pre-line;
  flex: 1;
`;

const ContentFrame = styled.iframe`
  width: 100%;
  flex: 1;
  min-height: 60vh;
  border: 1px solid #eee;
  border-radius: 8px;
  background: #fff;
`;

const BackBtn = styled.button`
  margin-top: 24px;
  width: 100%;
  padding: 12px 0;
  background: #eee;
  color: #333;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  cursor: pointer;
  flex-shrink: 0;
`;

export default function TermsDetailPage() {
  const { type } = useParams();
  const navigate = useNavigate();

  const terms = (type && TERMS_CONFIG[type]) || {
    title: '약관',
    content: '약관 내용을 찾을 수 없습니다.',
  };

  return (
    <Wrapper>
      <Title>{terms.title}</Title>
      {terms.url ? (
        <ContentFrame
          src={terms.url}
          title={terms.title}
          sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
        />
      ) : (
        <Content>{terms.content}</Content>
      )}
      <BackBtn onClick={() => navigate(-1)}>돌아가기</BackBtn>
    </Wrapper>
  );
}
